/** Mirrors ReportTableV2 “not marked yet” row logic */
const isClassNotMarkedYet = row => {
  const coreDone = row.lessonsCompletedCore ?? row.lessonsCompleted ?? 0
  const coreTotal = row.lessonCountCore ?? row.lessonCount ?? 0
  return coreDone === 0 && coreTotal > 0 && !row.hasCompletedLessonLastPeriod
}

/** Summary strip counts for the current filtered class list */
export const summarizeReportingClasses = classes => ({
  totalClassesCount: classes.length,
  numClassesMarkedLastPeriod: classes.filter(
    r => r.hasCompletedLessonLastPeriod,
  ).length,
  numClassesNotMarkedLesson: classes.filter(isClassNotMarkedYet).length,
})
